/**
 * Homepage chat — live canvas_chat API.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-chat-hp]');
  if (!root) return;

  var API_URL =
    (root.getAttribute('data-chat-hp-api-url') || '').trim() ||
    'https://canvastartai-v2.onrender.com/canvas_chat';
  var IMAGE_EDIT_URL = API_URL.replace(/\/canvas_chat(?:_v2|_bot_v2)?\/?$/, '/image_edit');
  var VARIANT_MAP_URL = (root.getAttribute('data-chat-hp-variant-map-url') || '').trim() || '';
  var DEFAULT_VARIANT_ID =
    (root.getAttribute('data-chat-hp-variant-id') || '').trim() || '57358129299759';
  var FRAME_SWATCH_URLS = {
    'No Frame': (root.getAttribute('data-chat-hp-frame-no-frame-url') || '').trim(),
    'Wood': (root.getAttribute('data-chat-hp-frame-wood-url') || '').trim(),
    'Dark Wood': (root.getAttribute('data-chat-hp-frame-dark-wood-url') || '').trim(),
    'Black': (root.getAttribute('data-chat-hp-frame-black-url') || '').trim(),
  };
  var FRAME_CANONICAL_LABELS = ['No Frame', 'No Frame (default)', 'Wood', 'Dark Wood', 'Black'];
  var messagesEl = root.querySelector('[data-chat-hp-messages]');
  var startersWrapEl = root.querySelector('[data-chat-hp-starters-wrap]');
  var heroEl = root.querySelector('[data-chat-hp-hero]');
  var chipsEl = root.querySelector('[data-chat-hp-chips]');
  var typingEl = root.querySelector('[data-chat-hp-typing]');
  var formEl = root.querySelector('[data-chat-hp-form]');
  var inputEl = root.querySelector('[data-chat-hp-input]');
  var sendBtn = root.querySelector('[data-chat-hp-send]');
  var uploadBtn = root.querySelector('[data-chat-hp-upload]');
  var fileInputEl = root.querySelector('[data-chat-hp-file]');
  var startersEl = root.querySelector('[data-chat-hp-starters]');

  var STARTERS = [
    {
      id: 'pet',
      label: 'Pet',
      imageUrl:
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/pet_dd3bf69a89dc45fa5c93bcae554432cf.png?v=1751918405',
      subject: 'pet canvas',
      starterReply:
        "Lovely choice — they deserve their own portrait. First, what shape should the canvas be?",
    },
    {
      id: 'dad',
      label: 'Dad',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/best_dad.png',
      subject: 'Dad canvas',
      starterReply: "Awesome — Dad is going to love this. First, what shape should the canvas be?",
    },
    {
      id: 'mom',
      label: 'Mom',
      imageUrl:
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_893ca0a261b1080b6f2fe3625ffc5d79.png',
      subject: 'Mom canvas',
      starterReply: "Beautiful pick — Mom will adore this. First, what shape should the canvas be?",
    },
    {
      id: 'daughter',
      label: 'Daughter',
      imageUrl:
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_7c76569198a0a04cfe188171a938a125.png?v=1751908377',
      subject: 'daughter canvas',
      starterReply: "Sweet — let's make her shine. First, what shape should the canvas be?",
    },
    {
      id: 'son',
      label: 'Son',
      imageUrl:
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_0bfb6cd95dec2d930dcb1b305ae3e10d.png?v=1751909225',
      subject: 'son canvas',
      starterReply: "Love this — let's celebrate the champ. First, what shape should the canvas be?",
    },
    {
      id: 'couple',
      label: 'Couple',
      imageUrl:
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_dee81497f84adee508a7bf11742644b3.png?v=1751912163',
      subject: 'couple canvas',
      starterReply: "Aww — this is going to be sweet. First, what shape should the canvas be?",
    },
    {
      id: 'family',
      label: 'Family',
      imageUrl:
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_7094259625bea8e7656c590543a6409c.png?v=1751911571',
      subject: 'family canvas',
      starterReply: "Wholesome — the whole crew on one canvas. First, what shape should it be?",
    },
  ];

  var ALLOWED_PROJECT_TYPES = [
    'pet',
    'dad',
    'mom',
    'daughter',
    'son',
    'couple',
    'family',
    'unknown',
  ];

  var LEGACY_PROJECT_TYPE_MAP = {
    pet_art: 'pet',
    couples: 'couple',
    single_person: 'unknown',
    art_pieces: 'unknown',
    other: 'unknown',
  };

  function normalizeProjectType(value) {
    if (!value) return value;
    if (LEGACY_PROJECT_TYPE_MAP[value]) return LEGACY_PROJECT_TYPE_MAP[value];
    if (ALLOWED_PROJECT_TYPES.indexOf(value) === -1) return 'unknown';
    return value;
  }

  function hasStarterSuggestion(suggestions) {
    if (!Array.isArray(suggestions) || !suggestions.length) return false;
    return suggestions.some(function (label) {
      var lowered = String(label || '').trim().toLowerCase();
      return STARTERS.some(function (s) {
        return lowered === String(s.label || '').toLowerCase() || lowered === String(s.id || '').toLowerCase();
      });
    });
  }

  function orientationImageUrl(id, fallback) {
    var attr = (root.getAttribute('data-chat-hp-orientation-' + id + '-url') || '').trim();
    return attr || fallback;
  }

  var ORIENTATION_OPTIONS = [
    {
      id: 'square',
      label: 'Square',
      message: 'Square',
      imageUrl: orientationImageUrl(
        'square',
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/square.png'
      ),
    },
    {
      id: 'portrait',
      label: 'Portrait',
      message: 'Portrait (tall)',
      imageUrl: orientationImageUrl(
        'portrait',
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/portrait.png'
      ),
    },
    {
      id: 'landscape',
      label: 'Landscape',
      message: 'Landscape (wide)',
      imageUrl: orientationImageUrl(
        'landscape',
        'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/landscape.png'
      ),
    },
  ];

  var STEP_SUGGESTIONS = {
    orientation: ['Square', 'Portrait (tall)', 'Landscape (wide)'],
    style: [
      'Realistic portrait',
      'Watercolor painting',
      'Oil painting',
      'Renaissance oil portrait',
      'Pop art comic',
      'Pixar 3D cartoon',
      'Van Gogh inspired',
    ],
    background: [
      'Studio backdrop',
      'Soft gradient',
      'Solid color',
      'Outdoor garden',
      'Beach at sunset',
      'Forest with light beams',
      'Starry night sky',
    ],
    action: [
      'Calm portrait close-up',
      'Sitting pose, looking at camera',
      'Playful running',
      'Cuddling close',
      'Standing proud',
    ],
    text: ['No text', 'Add a name'],
    upload: ['Upload reference photo'],
    ready: ['Generate image', 'Start over'],
  };

  var GENERATE_TRIGGERS = ['generate image', 'create preview', 'generate again'];
  var ADD_TO_CART_TRIGGERS = ['add to cart', 'add it to cart', 'try add again'];
  var VIEW_CART_TRIGGERS = ['view cart', 'go to cart'];
  var UPLOAD_TRIGGERS = ['upload reference photo', 'upload photo', 'upload reference'];
  var MANUAL_TRIGGERS = ["i'll do it manually", 'i will do it manually', 'do it manually', 'manual'];
  var PRIMARY_CHIP_LABELS = ['Generate image', 'Add to cart', 'View cart'];

  var GENERATE_PROGRESS_MESSAGES = [
    'Warming up the brushes…',
    'Sketching the composition…',
    'Painting in your style and colors…',
    'Adding the background and the little details…',
    'Polishing the final touches…',
    'Almost there — last brush strokes…',
  ];

  var PROJECT_TYPE_TO_PRESET_SET = {
    pet: 'pet',
    dad: 'dad',
    mom: 'mom',
    daughter: 'daughter',
    son: 'son',
    couple: 'couple',
    family: 'family',
    pet_art: 'pet',
    couples: 'couple',
  };

  var STYLE_PRESETS = {
    pet: [
      {
        id: 'memorial_watercolor',
        label: 'Memorial watercolor',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/pet_dd3bf69a89dc45fa5c93bcae554432cf.png?v=1751918405',
        prompt:
          'style: Digital watercolor with soft, blended brush strokes and subtle texture.; subject: Forever In Our Hearts; background: Minimalist white with beige and tan watercolor splashes; action: Calm, friendly expressions with gentle posture and upward gaze.',
      },
      {
        id: 'halloween',
        label: 'Halloween',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/halloween.png?v=1761002682',
        prompt:
          'style: Bright colorful; subject:; background: Halloween theme; action: Calm, friendly expressions with gentle posture and upward gaze.',
      },
      {
        id: 'ocean_run',
        label: 'Ocean run',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ocean.png?v=1761069445',
        prompt:
          'style: 8K photo; subject:; background: blue sky; action: Playfully running along the shore of the ocean, capturing joyful movement, with all unnecessary objects removed.',
      },
      {
        id: 'bubblegum_pop',
        label: 'Bubblegum pop',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/pet_colorful.png?v=1760489686',
        prompt:
          'style: Bright pop art realism with vivid and soft brush textures, and glossy highlights around the eyes and nose.; subject:; background: Horizontal rainbow stripes in warm-to-cool order with smooth blending, matte finish, and centered composition for strong color harmony; action: Pet faces forward blowing a round pink bubblegum bubble, ears perked, eyes wide and reflective, capturing playful stillness mid-blow.',
      },
      {
        id: 'van_gogh_beach',
        label: 'Van Gogh beach',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/Screenshot_2025-05-18_at_6.56.31_PM.png',
        prompt:
          'style: Van Gogh style.; subject:; background: blue sky; action: Playfully running on the beach, capturing joyful movement.',
      },
      {
        id: 'starry_night',
        label: 'Starry Night',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/starry.png',
        prompt:
          "style: Vincent van Gogh's Starry Night style with bold, swirling brush strokes and vivid blue and yellow palette; subject:; background: iconic swirling night sky with stars and moon, blending into rolling blue hills and abstract textures; action: Seated on a grassy hill, gazing upward as if part of the dreamlike scene.",
      },
      {
        id: 'pixar_3d',
        label: 'Pixar 3D',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/2f3a7a5d9da2f2904777ce41984993d9.jpg',
        prompt:
          'style: Pixar 3D cartoon; subject:; background: Soft white gradient; action: Relaxed pose lying on the ground, looking directly with joy.',
      },
      {
        id: 'studio_8k',
        label: 'Studio 8K photo',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/8k.png?v=1751471765',
        prompt:
          'style: Ultra-realistic 8K photographic portrait professionally edited with meticulous Photoshop techniques for supreme clarity and detail, preserving all the characteristics of the subjects; subject:; background: Seamless white or soft beige gradient with delicate shadowing; action: Bright, joyful expression with a gentle smile, relaxed and natural posture, eyes looking toward the camera with warmth and curiosity.',
      },
      {
        id: 'spaghetti_kitchen',
        label: 'Spaghetti kitchen',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/spagetti_f9e1f816-b422-47f8-b1ca-98f5854692ba.png',
        prompt:
          'style: Van Gogh style; subject:; background: Cozy kitchen interior with warm lighting; action: Playful moment of slurping spaghetti from a red plate, eyes wide with curiosity.',
      },
      {
        id: 'running_portrait',
        label: 'Running portrait',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/klasik.png',
        prompt:
          'style: High-detail digital painting with soft airbrush textures and dramatic lighting; subject:; background: Warm beige with painterly splash effects and soft gradients; action: Energetically running toward the viewer with fur in motion, joyful expression, red bow and fluffy texture emphasized.',
      },
      {
        id: 'flat_icon',
        label: 'Flat icon',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/eae180f095d7cb863bf3cf5c6ea43bfd_8c20ccbf34a021d3e541e6263612df93.jpg',
        prompt:
          'style: Flat icon illustration; subject:; background: solid light blue; action: Dynamic running motion with light, joyful energy.',
      },
      {
        id: 'sunlit_forest',
        label: 'Sunlit forest',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/oil_pet.png',
        prompt:
          'style: Realistic digital painting with warm, sunlit tones and soft brush strokes; subject:; background: Sun-dappled forest with glowing greenery; action: Joyful running toward the viewer with happy expression and flopping ears.',
      },
      {
        id: 'picasso_line',
        label: 'Picasso line',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/daaebdbff55898bfe6c120fcd6e7c528_8c20ccbf34a021d3e541e6263612df93.jpg',
        prompt:
          'style: Picasso one-line minimalist illustration; subject:; background: solid light blue; action: Expressive running silhouette with fluid lines.',
      },
      {
        id: 'vibrant_render',
        label: 'Vibrant render',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/521700f99ea905fd169d67c4078b05e5.jpg',
        prompt:
          'style: Digital rendering with smooth textures and a warm, vibrant palette.; subject:; background: Solid white; action: Upright posture with open expression, evoking excitement and playfulness.',
      },
      {
        id: 'outline_minimalist',
        label: 'Outline minimalist',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/5bac14c029a12009bb09ca87b9f7a905.jpg',
        prompt:
          'style: Outlines-only minimalist illustration; subject:; background: solid white; action: Simple headshot with happy and relaxed facial expressions.',
      },
      {
        id: 'royal_noble',
        label: 'Royal noble',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d14f0fdc1b260c30a8e5b090e778a161_8c20ccbf34a021d3e541e6263612df93.jpg',
        prompt:
          'style: Digital art with regal tone and rich color palette of gold, red, and brown.; subject:; background: Dramatic cloudy sky in muted grays and blues; action: Majestic seated posture with crown and robe, evoking noble elegance.',
      },
      {
        id: 'comic_pop',
        label: 'Comic pop art',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/popart.png',
        prompt:
          'style: Bold pop art comic book style with halftone textures and vibrant, contrasting colors.; subject:; background: Bursting starburst pattern in red, yellow, and blue; action: Heroic pose with head turned sideways like a comic character intro panel.',
      },
      {
        id: 'asian_ink',
        label: 'Asian ink',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/asian_oil.png',
        prompt:
          'style: Traditional Asian ink and wash painting with soft brush strokes and ink blots; subject:; background: Gentle gray tones with misty trees or abstract nature; action: Calm seated pose with thoughtful expression and tranquil atmosphere.',
      },
      {
        id: 'glowing_silhouette',
        label: 'Glowing silhouette',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/glowing.png',
        prompt:
          'style: Silhouette art with glowing edges and a dreamy sunset color palette of pink, orange, and purple; subject:; background: Vibrant horizon blending into stars; action: Silhouette standing or sitting with majestic posture against the sunset.',
      },
      {
        id: 'renaissance',
        label: 'Renaissance',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/renaisance.png',
        prompt:
          'style: Classic renaissance-style oil painting with textured brushwork and rich earth tones; subject:; background: Dramatic curtain and dark textured wall; action: Regal pose with upward gaze, resembling a historical painted noble.',
      },
      {
        id: 'bohemian_botanic',
        label: 'Bohemian botanic',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/botanic.png',
        prompt:
          'style: Soft bohemian watercolor with botanical leaves and floral wreaths; subject:; background: Light beige or pastel background with natural leaf elements; action: Relaxed close-up portrait with gentle expression, as if posing in nature.',
      },
    ],
    dad: [
      {
        id: 'best_dad_pixar',
        label: 'Best Dad ever',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/best_dad.png',
        prompt:
          'style: Pixar 3D cartoon; subject: Best DAD Ever; background: Soft white gradient; action: Reclining, flashing a peace sign, looking directly with joy.',
      },
      {
        id: 'baseball_swing',
        label: 'Baseball swing',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_c56a16828eb3b2805792e560cdeb8cc2.png?v=1751904312',
        prompt:
          'style: Pixar 3D cartoon; subject:; background: Green baseball field under stadium lights; action: Dad swinging a bat in full baseball uniform.',
      },
      {
        id: 'super_dad_comic',
        label: 'Super Dad',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_dbd5db5a92c1c221039e914d93aef8b3.png?v=1751904451',
        prompt:
          'style: Comic-book illustration with bold outlines and vivid flat colors; subject: Super DAD; background: Stylized city skyline at sunset; action: Dad standing heroically with hands on hips, cape billowing and emblem shining.',
      },
      {
        id: 'birthday_candles',
        label: 'Birthday candles',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_3e6ac88be53b7057e3c1ae382bfa631e.png?v=1751904492',
        prompt:
          'style: Soft digital watercolor with glowing highlights; subject:; background: Warm candlelight glow with floating confetti; action: Dad leaning in to blow out candles on a cake.',
      },
      {
        id: 'bike_ride_dad',
        label: 'Bike ride',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_68b2235cf8cff473e4748a462e29a8ab.png?v=1751904541',
        prompt:
          'style: High-contrast pop-art with halftone dot textures; subject:; background: Bold blocks of red, yellow, and blue; action: Dad riding a bicycle in dynamic motion.',
      },
      {
        id: 'skater_dad',
        label: 'Skater Dad',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_0868e3c2a7d84d417a5afa2733d6e586.png?v=1751904583',
        prompt:
          'style: Flat icon illustration; subject:; background: Solid light blue; action: Dad performing a kickflip on a skateboard.',
      },
      {
        id: 'cake_smash_toddler',
        label: 'Cake smash',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_d13305cb68e18a75c2325f082e178f9f.png?v=1751904632',
        prompt:
          'style: Whimsical pastel cartoon with soft shadows; subject:; background: Festive balloons and buntings; action: Dad playfully smashing cake with a toddler.',
      },
      {
        id: 'backyard_bbq',
        label: 'Backyard BBQ',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_0808741e1907311113136176c03eb115.png?v=1751904679',
        prompt:
          'style: Realistic digital painting with warm, sunlit tones; subject:; background: Backyard barbecue scene with gentle smoke; action: Dad flipping burgers at the grill.',
      },
      {
        id: 'nature_walk_dad',
        label: 'Nature walk',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_7ec62ad1667ec4cf2c6b5bd25d04a946.png?v=1751904728',
        prompt:
          'style: Gentle bohemian watercolor with botanical accents; subject:; background: Soft pastel trail framed by trees; action: Dad walking outdoors enjoying nature.',
      },
      {
        id: 'gamer_dad',
        label: 'Gamer Dad',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_6f648d1870ef2a2ca3aa60ab67612838.png?v=1751904777',
        prompt:
          'style: Neon cyberpunk digital art with glowing accents; subject:; background: Futuristic gaming setup with LED lights; action: Dad gripping a game controller in intense focus.',
      },
      {
        id: 'lake_fishing',
        label: 'Lake fishing',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_aa3f96bcdbb5bdfd8ded44ad738a700b.png?v=1751904823',
        prompt:
          'style: Impressionist oil painting with rich, textured brushstrokes; subject:; background: Misty lakeshore at sunrise; action: Dad casting a fishing line from a wooden dock.',
      },
      {
        id: 'mountain_hike',
        label: 'Mountain hike',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f1a22e7a15fcc730a8b83e2266cc9a44_2f86d404b5f7fdc72e21170cd09bc642.png?v=1751904868',
        prompt:
          'style: Vintage travel-poster flat illustration; subject:; background: Stylized mountain peaks and pine forest; action: Dad hiking with a backpack, pointing toward the horizon.',
      },
    ],
    mom: [
      {
        id: 'best_mom_pixar',
        label: "World's best Mom",
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_893ca0a261b1080b6f2fe3625ffc5d79.png',
        prompt:
          "style: Pixar 3D cartoon; subject: World's Best MOM; background: Soft pink gradient with sparkles; action: Reclining on a cozy chair, holding a mug with a warm smile, looking directly with joy.",
      },
      {
        id: 'garden_tea',
        label: 'Garden tea',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_5e4b08328cd66a3b5cf8e9f42363eaf7.png?v=1751978371',
        prompt:
          'style: Studio Ghibli watercolor with gentle pastel tones; subject:; background: Cozy garden with blooming flowers; action: Mom sitting on a wooden bench with a soft smile, holding a cup of tea, surrounded by calm nature.',
      },
      {
        id: 'painting_mom',
        label: 'Painting Mom',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_842ac3ed6e27beb93caa623d995f3653.png?v=1751905252',
        prompt:
          'style: Soft digital watercolor with glowing highlights; subject:; background: Candle-lit art studio at dusk; action: Mom painting an abstract artwork on a canvas.',
      },
      {
        id: 'yoga_in_flowers',
        label: 'Yoga in flowers',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_d355194e409d77cc497d471f2137b051.png?v=1751905299',
        prompt:
          'style: Gentle bohemian watercolor with botanical accents; subject:; background: Sunny flower meadow; action: Mom practicing yoga with serene calmness among wildflowers.',
      },
      {
        id: 'boss_mom',
        label: 'Boss Mom',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_aed259cc726bbc67c34265168982a940.png?v=1751905354',
        prompt:
          'style: Comic-book illustration with bold outlines and vivid flat colors; subject:; background: Stylized skyline at golden hour; action: Mom confidently presenting at a business meeting with superhero cape fluttering.',
      },
      {
        id: 'garden_harvest',
        label: 'Garden harvest',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_004ce1516ebfcb98f6b1fb9fde587b9d.png?v=1751905403',
        prompt:
          'style: Realistic digital painting with warm, sunlit tones; subject:; background: Backyard garden in bloom; action: Mom harvesting vegetables from her thriving organic garden.',
      },
      {
        id: 'rockstar_mom',
        label: 'Rockstar Mom',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_e9bf6762372fefed5f7b5dfb8b2cda1a.png?v=1751905455',
        prompt:
          'style: High-contrast pop-art with halftone dot textures; subject:; background: Vibrant comic panel layout; action: Mom energetically playing an electric guitar.',
      },
      {
        id: 'cookie_kitchen',
        label: 'Cookie kitchen',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_73b965eaaee20a7e838448de972b2d6d.png?v=1751905499',
        prompt:
          'style: Whimsical pastel cartoon with soft shadows; subject:; background: Festive kitchen with colorful decorations; action: Mom joyfully decorating cookies with her child.',
      },
      {
        id: 'city_bike_mom',
        label: 'City bike',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_7260bba1d02e48d665cb70baa7f47b21.png?v=1751905540',
        prompt:
          'style: Flat icon illustration; subject:; background: Solid pastel purple; action: Mom riding a bicycle through the city with fresh flowers in her basket.',
      },
      {
        id: 'sunset_kayak',
        label: 'Sunset kayak',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_959ed0c238a3d8bb929b346821651aca.png?v=1751905588',
        prompt:
          'style: Impressionist oil painting with rich, textured brushstrokes; subject:; background: Lakeside dock at sunset; action: Mom kayaking gracefully across the peaceful lake.',
      },
      {
        id: 'cyber_mom',
        label: 'Cyber Mom',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/476647341fd5596c3ab692b44f63ef1b_e7759bb305a40ae0bdd3c00557ebce44.png?v=1751905646',
        prompt:
          'style: Neon cyberpunk digital art with glowing accents; subject:; background: Futuristic home office with floating UI screens; action: Mom confidently managing virtual screens, engaged in creative work.',
      },
    ],
    daughter: [
      {
        id: 'figure_skater',
        label: 'Figure skater',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_7c76569198a0a04cfe188171a938a125.png?v=1751908377',
        prompt:
          'style: Pixar 3D cartoon; subject: Our Fireball; background: Shimmering ice rink with dramatic spotlight; action: Daughter performing an elegant figure skating jump.',
      },
      {
        id: 'cherry_blossoms',
        label: 'Cherry blossoms',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_9b30bf7a37ef21e65f7106c17f734513.png?v=1751978415',
        prompt:
          'style: Studio Ghibli-style watercolor with dreamy lighting; subject:; background: Open park with cherry blossom petals falling; action: Daughter holding a balloon, smiling with joy and looking up slightly.',
      },
      {
        id: 'piano_recital',
        label: 'Piano recital',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_be9ffdebe72ee0428b74ec5c04e5a248.png?v=1751908427',
        prompt:
          'style: Soft digital watercolor with glowing highlights; subject:; background: Cozy, warmly-lit music room; action: Daughter gracefully playing piano, deeply immersed in her music.',
      },
      {
        id: 'graduation_toss',
        label: 'Graduation toss',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_f88c9e62353426f16b90b321aeb5c719.png?v=1751908468',
        prompt:
          'style: Gentle bohemian watercolor with floral accents; subject:; background: Bright spring meadow; action: Daughter joyfully throwing her graduation cap into the air, celebrating her achievement.',
      },
      {
        id: 'valedictorian',
        label: 'Valedictorian',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_c364e3cfce65ab84b27b923504d683ff.png?v=1751908518',
        prompt:
          'style: Comic-book illustration with bold outlines and vivid colors; subject:; background: High-school auditorium stage with lights and cheering crowd; action: Daughter confidently delivering a valedictorian speech.',
      },
      {
        id: 'dance_vibes',
        label: 'Dance vibes',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_f658e014587e23104831dd754c9558e9.png?v=1751908868',
        prompt:
          'style: High-contrast pop-art with halftone dot textures; subject:; background: Colorful abstract patterns; action: Daughter energetically dancing to music, headphones on, lost in rhythm.',
      },
      {
        id: 'baker_daughter',
        label: 'Cupcake baker',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_55ad7368e352a13160885c30842e4e58.png?v=1751908914',
        prompt:
          'style: Whimsical pastel cartoon with soft shadows; subject:; background: Cheerful kitchen scene; action: Daughter happily baking cupcakes, wearing a playful apron.',
      },
      {
        id: 'skater_girl',
        label: 'Skater girl',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_6b1ffd24fff475c44b7fe25be5ed44e6.png?v=1751908948',
        prompt:
          'style: Flat icon illustration; subject:; background: Solid pastel turquoise; action: Daughter riding a skateboard with confidence, hair flowing behind her.',
      },
      {
        id: 'beach_yoga',
        label: 'Beach yoga',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_dddd24d1b3698a61d6b410707923abc5.png?v=1751908991',
        prompt:
          'style: Impressionist oil painting with textured brushstrokes; subject:; background: Sunny beach at sunset; action: Daughter practicing yoga by the shore, peacefully balanced.',
      },
      {
        id: 'future_coder',
        label: 'Future coder',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/f65cf26c118005ab592273abcf8cde3a_a886b6d6dab35b013d032cf9164499e3.png?v=1751909041',
        prompt:
          'style: Neon cyberpunk digital art with glowing accents; subject:; background: Futuristic cityscape; action: Daughter confidently coding on holographic interfaces, creating future technologies.',
      },
    ],
    son: [
      {
        id: 'hockey_champion',
        label: 'Hockey star',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_0bfb6cd95dec2d930dcb1b305ae3e10d.png?v=1751909225',
        prompt:
          'style: Pixar 3D cartoon; subject: Our Little Champion; background: Icy hockey rink under bright arena lights; action: Son mid-action with hockey stick, scoring a goal with determination.',
      },
      {
        id: 'drum_solo',
        label: 'Drum solo',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_ba7fb53bd051bd254c118bab29dcdbc2.png?v=1751909272',
        prompt:
          'style: Soft digital watercolor with glowing highlights; subject:; background: Cozy room with posters and beanbags; action: Son passionately playing a full drum kit, eyes closed in rhythm.',
      },
      {
        id: 'joyful_run',
        label: 'Joyful run',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_ffda9a6792979c61717ebe35b44567e9.png?v=1751978470',
        prompt:
          'style: Studio Ghibli-style illustration with bright and airy palette; subject:; background: Peaceful street with soft hills in the distance; action: Son in casual clothes, arms stretched in excitement, joyful expression.',
      },
      {
        id: 'birthday_boy',
        label: 'Birthday boy',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_a3e504ea6e2d9110ed5ccd98ada5f68c.png?v=1751909323',
        prompt:
          'style: Gentle bohemian watercolor with warm lighting; subject:; background: Birthday party scene with balloons and cake; action: Son blowing out candles on a 12th birthday cake, surrounded by joy.',
      },
      {
        id: 'lego_master',
        label: 'Lego master',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_ef5aeb68d064cacab087b8ed1df965f6.png?v=1751909372',
        prompt:
          'style: Comic-book illustration with energetic lines and bright color splashes; subject:; background: Bedroom with scattered Lego bricks; action: Son proudly placing the final piece on a massive Lego castle.',
      },
      {
        id: 'stargazer',
        label: 'Stargazer',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_be855a01323f216d9575e1fdf4ce6498.png?v=1751909421',
        prompt:
          'style: Realistic digital painting with golden-hour glow; subject:; background: Backyard with telescope and campfire; action: Son stargazing through a telescope, notebook in hand, deeply curious.',
      },
      {
        id: 'rockstar_jump',
        label: 'Rockstar jump',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_96d0fc0bfd6f8fb42bf9ad8d742c1620.png?v=1751909474',
        prompt:
          'style: High-contrast pop-art with dynamic halftones; subject:; background: Vibrant concert stage backdrop; action: Son jumping with a toy guitar like a rockstar, full of excitement.',
      },
      {
        id: 'skater_son',
        label: 'Skater',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_0be86e913f0d3f5a7450e13dddedbf54.png?v=1751909559',
        prompt:
          'style: Flat icon illustration; subject:; background: Solid light blue; action: Son skateboarding with one hand in the air, wearing a cool helmet and big smile.',
      },
      {
        id: 'stone_skipping',
        label: 'Stone skipping',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_3f74fb98609abd377bf726b8c43577cf.png?v=1751909604',
        prompt:
          'style: Impressionist oil painting with colorful strokes; subject:; background: Lakeside in summer; action: Son skipping stones across the water, concentration on his face.',
      },
      {
        id: 'vr_hero',
        label: 'VR hero',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/ed0cd0481f95b2b0502df24fd3fcfe67_f6f78aa423271a4dcea9efdc879f93d6.png?v=1751909653',
        prompt:
          'style: Neon cyberpunk digital art with glowing trails; subject:; background: Futuristic gaming room with virtual reality gear; action: Son battling in VR with energy blades, immersed in adventure.',
      },
    ],
    couple: [
      {
        id: 'eiffel_proposal',
        label: 'Eiffel proposal',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_dee81497f84adee508a7bf11742644b3.png?v=1751912163',
        prompt:
          'style: Pixar 3D cartoon; subject: Forever Begins Here; background: Eiffel Tower under twinkling lights at dusk; action: Man proposing on one knee as woman gasps with joyful surprise.',
      },
      {
        id: 'cabin_cocoa',
        label: 'Cabin cocoa',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_0cf93ca701a6a47fad99e4c0b6ea54b3.png?v=1751912212',
        prompt:
          'style: Soft digital watercolor with glowing blush tones; subject:; background: Cozy mountain cabin interior with a crackling fireplace; action: Couple wrapped in one blanket sipping hot cocoa, eyes locked.',
      },
      {
        id: 'meadow_dance',
        label: 'Meadow dance',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_8766672b738bb255ea32b07b59010dc4.png?v=1751912260',
        prompt:
          'style: Gentle bohemian watercolor with floral borders; subject:; background: Open meadow with a picnic setup under a tree; action: Couple dancing barefoot in the grass to music only they can hear.',
      },
      {
        id: 'golden_hour_couple',
        label: 'Golden hour',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_b9b1aa9f3b048caa7720b7db7f225e47.png?v=1751978519',
        prompt:
          'style: Studio Ghibli watercolor with romantic tones; subject:; background: Quiet hilltop during golden hour; action: Couple holding hands and smiling at each other, gentle breeze in their hair.',
      },
      {
        id: 'road_trip_couple',
        label: 'Road trip',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_0e72f844aa1b8d56fd4ea1a62bd4844b.png?v=1751912307',
        prompt:
          'style: Comic-book pop-art with vibrant tones and motion lines; subject:; background: Retro-style road trip scene with convertible; action: Couple high-fiving with wind blowing as they speed down a highway.',
      },
      {
        id: 'sunset_footprints',
        label: 'Sunset footprints',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_535a5637e21dde920674b0f8ca516b90.png?v=1751912353',
        prompt:
          'style: Realistic digital painting with golden-hour lighting; subject:; background: Beach at sunset; action: Couple walking barefoot on wet sand, leaving heart-shaped footprints behind them.',
      },
      {
        id: 'neon_rain',
        label: 'Neon rain',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_ee8194dae2d17d3adbb9dbb42cc0f718.png?v=1751912421',
        prompt:
          'style: Neon cyberpunk with holographic reflections; subject:; background: Futuristic Tokyo skyline with glowing billboards; action: Couple holding hands under umbrellas as neon rain falls.',
      },
      {
        id: 'campfire_marshmallows',
        label: 'Campfire night',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_f4d460d0a5002c6f8264f8a81bcdd1aa.png?v=1751912467',
        prompt:
          'style: Whimsical pastel cartoon with sparkly sky; subject:; background: Starry night campsite under fairy lights; action: Couple roasting marshmallows and laughing by the fire.',
      },
      {
        id: 'venice_gondola',
        label: 'Venice gondola',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_760448263cb01f8b3cdf5cd4e776a3de.png?v=1751912513',
        prompt:
          'style: Impressionist oil painting with soft blends; subject:; background: Gondola ride through Venice at twilight; action: Couple kissing under a small stone bridge, reflections rippling below.',
      },
      {
        id: 'coral_sparkle',
        label: 'Coral sparkle',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_6289e5bb098dba87d08fb35494e24256.png?v=1751912557',
        prompt:
          'style: Minimalist flat vector style; subject:; background: Solid coral background with simple white silhouettes; action: Couple forehead to forehead, outlined in subtle gold sparkles.',
      },
      {
        id: 'cliffside_epic',
        label: 'Cliffside epic',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/afd86538c1ea44d48da539e17ce277db_30e7df478454bce9a1ab1319745d8127.png?v=1751912606',
        prompt:
          'style: Dramatic cinematic digital art; subject:; background: Cliffside with sweeping clouds and ocean view; action: Couple standing on the edge holding each other tightly against the wind.',
      },
    ],
    family: [
      {
        id: 'together_forever_family',
        label: 'Together forever',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_7094259625bea8e7656c590543a6409c.png?v=1751911571',
        prompt:
          'style: Pixar 3D cartoon; subject: Together Forever; background: Vibrant park at golden hour with glowing fireflies; action: Family members sharing a warm group hug that bursts into confetti hearts.',
      },
      {
        id: 'hillside_meadow',
        label: 'Hillside meadow',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_2c169115d35ee90e1e21bc25e29741f3.png?v=1751977587',
        prompt:
          'style: Studio Ghibli-inspired soft watercolor with hand-drawn charm; subject: Cherished Companionship; background: Peaceful hillside meadow with wildflowers and distant mountains; action: Loved ones standing close together, smiling warmly, with a soft breeze gently lifting their clothes and hair.',
      },
      {
        id: 'morning_kitchen',
        label: 'Morning kitchen',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_455853b4269f14240d5b5500397fd864.png?v=1751911624',
        prompt:
          'style: Soft digital watercolor with dreamy highlights; subject: Morning Moments; background: Rustic kitchen bathed in sunlight; action: Family or loved ones cooking breakfast together, laughter filling the air.',
      },
      {
        id: 'joyful_dance',
        label: 'Joyful dance',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_bfbef1891c7764cce4b4f025072bebf1.png?v=1751911676',
        prompt:
          'style: Gentle bohemian watercolor with floral accents; subject: Joyful Unity; background: Open meadow filled with wildflowers; action: Family or friends dancing in a circle, ribbons trailing from hands in joyful motion.',
      },
      {
        id: 'rooftop_heroes',
        label: 'Rooftop heroes',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_fd8087a1cb00aaca29f6405863c2d4b5.png?v=1751911732',
        prompt:
          'style: Comic-book illustration with bold outlines and dynamic panels; subject: Everyday Heroes; background: Stylized city skyline at sunset; action: Family members striking playful superhero poses atop a rooftop.',
      },
      {
        id: 'movie_night',
        label: 'Movie night',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_60bd39cf967540ae04eef76b0fb54b41.png?v=1751911782',
        prompt:
          'style: Realistic digital painting with warm, sun-kissed tones; subject: Cozy Connection; background: Backyard movie night with string lights; action: Family or friends snuggled under blankets, watching a glowing outdoor screen.',
      },
      {
        id: 'color_jump',
        label: 'Color jump',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_0319eea3cb5e1b7fdc7910ca398139ba.png?v=1751911838',
        prompt:
          'style: High-contrast pop-art with halftone dot textures; subject: Energy and Togetherness; background: Exploding color splashes; action: Family or loved ones mid-jump in matching sneakers, freeze-framed like a fun band poster.',
      },
      {
        id: 'sweet_kitchen_family',
        label: 'Sweet kitchen',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_a1125665831ec03e259b803b0b93bfff.png?v=1751911889',
        prompt:
          'style: Whimsical pastel cartoon with soft shadows; subject: Sweet Moments; background: Kitchen filled with balloon animals; action: Family or close friends decorating cupcakes, icing and sprinkles swirling like animated magic.',
      },
      {
        id: 'tandem_bike',
        label: 'Tandem bike',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_a3628f3d0fa93c5f33daf288b1eb3ef9.png?v=1751911939',
        prompt:
          'style: Flat icon illustration; subject: The Journey Together; background: Solid teal backdrop; action: Family members pedaling a tandem or side-by-side bicycle—simple shapes and bold colors for a modern, flexible look.',
      },
      {
        id: 'pier_kite',
        label: 'Pier kite',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_78c25992a44330f9d1bf3d72001ba1c4.png?v=1751912000',
        prompt:
          'style: Impressionist oil painting with thick, lively strokes; subject: Love in Motion; background: Ocean pier at sunset; action: Family or loved ones flying a giant rainbow kite, reflections shimmering on water.',
      },
      {
        id: 'neon_park',
        label: 'Neon park',
        imageUrl:
          'https://cdn.shopify.com/s/files/1/0588/8357/1791/files/d0282fbbe45da7966ca2dc188c81a041_c22f0c6d676d997711b9c8f7325e9aca.png?v=1751912055',
        prompt:
          'style: Neon cyberpunk digital art with glowing accents; subject: Playful Bond; background: Futuristic amusement park with holographic rides; action: Family or loved ones enjoying hovering bumper cars, neon trails spelling laughter.',
      },
    ],
  };

  function presetSetForCanvas(canvas) {
    if (!canvas || !canvas.project_type) return null;
    return PROJECT_TYPE_TO_PRESET_SET[canvas.project_type] || null;
  }

  function findPresetById(presetSet, presetId) {
    var presets = STYLE_PRESETS[presetSet];
    if (!presets) return null;
    for (var i = 0; i < presets.length; i++) {
      if (presets[i] && presets[i].id === presetId) return presets[i];
    }
    return null;
  }

  function parsePresetPrompt(prompt) {
    var out = { style: '', subject: '', background: '', action: '' };
    String(prompt || '')
      .split(';')
      .forEach(function (segment) {
        var seg = segment.trim();
        var idx = seg.indexOf(':');
        if (idx === -1) return;
        var key = seg.slice(0, idx).trim().toLowerCase();
        var value = seg.slice(idx + 1).trim();
        if (key && value && Object.prototype.hasOwnProperty.call(out, key)) {
          out[key] = value;
        }
      });
    return out;
  }

  var state = {
    history: [],
    canvas: null,
    threadSummary: '',
    threadTitle: '',
    pending: false,
    uploading: false,
    generating: false,
    addingToCart: false,
    lastImageUrl: '',
    lastPrintImageUrl: '',
    generatedImages: [], // [{ id, number, previewUrl, printUrl, canvas, createdAt }]
    activeImageId: '',
    userScrolledUp: false,
    variantMap: null,
    checkoutStep: '', // '', 'size', 'frame'
  };

  function formatMoney(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return '$' + (n / 100).toFixed(0) + (n % 100 ? (n / 100).toFixed(2).slice(-3) : '');
  }

  function orientationKey(canvas) {
    var o = String((canvas && canvas.orientation) || '').toLowerCase().trim();
    if (o === 'square' || o === 'portrait' || o === 'landscape') return o;
    return '';
  }

  function sizeKey(canvas) {
    var s = String((canvas && canvas.size) || '').trim();
    if (!s) return '';
    var lowered = s.toLowerCase();
    if (lowered.indexOf('small') === 0) return 'Small';
    if (lowered.indexOf('medium') === 0) return 'Medium';
    if (lowered.indexOf('large') === 0) return 'Large';
    return s;
  }

  function frameKey(canvas) {
    var f = String((canvas && canvas.frame) || '').trim();
    if (!f) return '';
    if (/^no\s*frame/i.test(f)) return 'No Frame';
    if (/^dark\s*wood/i.test(f)) return 'Dark Wood';
    if (/^wood/i.test(f)) return 'Wood';
    if (/^black/i.test(f)) return 'Black';
    return f;
  }

  function variantForSelection(canvas) {
    var map = state.variantMap && state.variantMap.by_orientation;
    if (!map) return null;
    var o = orientationKey(canvas);
    var s = sizeKey(canvas);
    var f = frameKey(canvas);
    if (!o || !s || !f) return null;
    var byO = map[o];
    if (!byO || !byO.variants || !byO.variants[s] || !byO.variants[s][f]) return null;
    return byO.variants[s][f];
  }

  function availableSizesFor(canvas) {
    var map = state.variantMap && state.variantMap.by_orientation;
    var o = orientationKey(canvas);
    if (!map || !o || !map[o] || !map[o].sizes) return null;
    return map[o].sizes;
  }

  function availableFramesFor(canvas) {
    var map = state.variantMap && state.variantMap.by_orientation;
    var o = orientationKey(canvas);
    var s = sizeKey(canvas);
    if (!map || !o || !s) return null;
    var byO = map[o];
    if (!byO || !byO.variants || !byO.variants[s]) return null;
    return Object.keys(byO.variants[s] || {});
  }

  function isFrameUnavailableForSelection(canvas) {
    // Business rule: Square + Medium has no frame options. Also applies as a fallback
    // when our mapping can't find any framed variant for the selection.
    var o = orientationKey(canvas);
    var s = sizeKey(canvas);
    if (o === 'square' && s === 'Medium') return true;
    var frames = availableFramesFor(canvas);
    if (!frames) return true;
    // If the only "frame" is No Frame, treat this as "no frame selection available".
    if (frames.length === 1 && frames[0] === 'No Frame') return true;
    return false;
  }

  function ensureFrameDefaultIfUnavailable() {
    if (!state.canvas) return false;
    if (!state.canvas.size) return false;
    if (!orientationKey(state.canvas)) return false;
    if (!isFrameUnavailableForSelection(state.canvas)) return false;
    if (state.canvas.frame && frameKey(state.canvas) === 'No Frame') return true;
    state.canvas = Object.assign({}, state.canvas, { frame: 'No Frame' });
    return true;
  }

  function beginCheckoutSizingFlow() {
    state.checkoutStep = 'size';
    // Always reset selections when we have a fresh preview.
    state.canvas = Object.assign({}, state.canvas || {}, { size: '', frame: '' });
    promptSizePick();
  }

  function promptSizePick() {
    var c = state.canvas || {};
    var o = orientationKey(c);
    if (!o) {
      appendAssistant('First, pick the canvas shape above.', []);
      return;
    }
    var sizes = availableSizesFor(c);
    var labels = sizes
      ? Object.keys(sizes)
          .filter(function (k) {
            return k === 'Small' || k === 'Medium' || k === 'Large';
          })
          .map(function (k) {
            var info = sizes[k] || {};
            var dim = info.label ? ' (' + info.label.replace(' inches', '') + ')' : '';
            return k + dim;
          })
      : ['Small', 'Medium', 'Large'];
    // Pass chips via appendAssistant so they render in the queued message
    // task (right after this bubble finishes typing). Calling addChips
    // synchronously here would be wiped by the empty-chips clear at the
    // end of streaming.
    appendAssistant('Pick a size:', labels);
  }

  function promptFramePick() {
    state.checkoutStep = 'frame';
    if (isFrameUnavailableForSelection(state.canvas || {})) {
      state.canvas = Object.assign({}, state.canvas || {}, { frame: 'No Frame' });
      appendAssistant('Frames are not available for this size, so we will use No Frame.', []);
      appendAssistant('Ready to add it to cart?', ['Add to cart', 'Generate again', 'Start over']);
      if (window.DiscoCountdown && typeof window.DiscoCountdown.start === 'function') {
        window.DiscoCountdown.start();
      }
      return;
    }
    appendAssistant('Optional frame (default: No Frame):', []);
    var frames = availableFramesFor(state.canvas);
    var frameLabels = frames && frames.length ? frames.slice() : ['No Frame', 'Wood', 'Dark Wood', 'Black'];
    appendFramePicker(frameLabels);
    // Frame picks happen inline in the thread, so clear the bottom chips row.
    clearChips();
    persistedChips = [];
    savePersistedSession();
  }

  function loadVariantMap() {
    if (!VARIANT_MAP_URL) return Promise.resolve(null);
    return fetch(VARIANT_MAP_URL, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        state.variantMap = json && typeof json === 'object' ? json : null;
        return state.variantMap;
      })
      .catch(function () {
        state.variantMap = null;
        return null;
      });
  }
  var scrollAnchorEl = document.createElement('div');
  scrollAnchorEl.className = 'chat-hp__scroll-anchor';
  if (messagesEl) messagesEl.appendChild(scrollAnchorEl);

  var STORAGE_KEY = 'canvastart_chat_session_v1';
  var STORAGE_TTL_MS = 14 * 24 * 60 * 60 * 1000;
  var STORAGE_MAX_MESSAGES = 200;
  var persistedMessages = [];
  var persistedChips = [];

  function loadPersistedSession() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || data.v !== 1) return null;
      if (typeof data.ts !== 'number' || Date.now() - data.ts > STORAGE_TTL_MS) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function savePersistedSession() {
    try {
      if (!window.localStorage) return;
      if (persistedMessages.length > STORAGE_MAX_MESSAGES) {
        persistedMessages = persistedMessages.slice(-STORAGE_MAX_MESSAGES);
      }
      var payload = {
        v: 1,
        ts: Date.now(),
        state: {
          history: state.history,
          canvas: state.canvas,
          threadSummary: state.threadSummary,
          threadTitle: state.threadTitle,
          lastImageUrl: state.lastImageUrl,
          lastPrintImageUrl: state.lastPrintImageUrl,
          generatedImages: state.generatedImages,
          activeImageId: state.activeImageId,
        },
        messages: persistedMessages,
        chips: Array.isArray(persistedChips) ? persistedChips : [],
      };
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function clearPersistedSession() {
    try {
      if (window.localStorage) window.localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatBody(text) {
    var t = escapeHtml(text).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    return '<p>' + t.replace(/\n/g, '<br>') + '</p>';
  }

  function isNearBottom() {
    if (!messagesEl) return true;
    return messagesEl.scrollHeight - messagesEl.scrollTop - messagesEl.clientHeight < 120;
  }

  function scrollDown(force) {
    if (!messagesEl || !scrollAnchorEl) return;
    if (!force && state.userScrolledUp && !isNearBottom()) return;
    var apply = function () {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    };
    apply();
    window.requestAnimationFrame(apply);
    window.setTimeout(apply, 80);
  }

  // Hide both the hero block (title + image + perks) and the starter
  // category cards once the user starts a chat — otherwise they take up
  // big vertical space and push actual messages to the bottom of an
  // empty container, leaving an obvious dead zone in the middle.
  function hideStartersBlock() {
    if (startersWrapEl) startersWrapEl.hidden = true;
    if (heroEl) heroEl.hidden = true;
  }

  function showStartersBlock() {
    if (startersWrapEl) startersWrapEl.hidden = false;
    if (heroEl) heroEl.hidden = false;
  }

  function clearChips() {
    if (chipsEl) chipsEl.innerHTML = '';
  }

  function setChipDisabled(disabled) {
    if (chipsEl) {
      chipsEl.querySelectorAll('button').forEach(function (b) {
        b.disabled = !!disabled;
      });
    }
    if (messagesEl) {
      messagesEl
        .querySelectorAll('.chat-hp__preset, .chat-hp__orientation')
        .forEach(function (b) {
          b.disabled = !!disabled;
        });
    }
  }

  function addChips(labels, onPick, primaryLabelsOpt) {
    clearChips();
    if (!chipsEl || !labels || !labels.length) return;
    var primaries =
      primaryLabelsOpt != null && primaryLabelsOpt.length ? primaryLabelsOpt : PRIMARY_CHIP_LABELS;
    labels.slice(0, 7).forEach(function (label) {
      var clean = String(label || '').trim();
      if (!clean) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'chat-hp__chip';
      if (primaries.indexOf(clean) !== -1) {
        b.classList.add('chat-hp__chip--primary');
      }
      b.textContent = clean;
      b.addEventListener('click', function () {
        onPick(clean);
      });
      chipsEl.appendChild(b);
    });
  }

  // Returns true when every label in the array maps to a known frame option.
  // Used to migrate legacy persisted chips into the new in-thread picker on restore.
  function chipsLookLikeFrameOptions(labels) {
    if (!labels || !labels.length) return false;
    for (var i = 0; i < labels.length; i++) {
      if (FRAME_CANONICAL_LABELS.indexOf(String(labels[i] || '').trim()) === -1) {
        return false;
      }
    }
    return true;
  }

  function customerIdForUsage() {
    var raw = (root.getAttribute('data-chat-hp-customer-id') || '').trim();
    if (!raw || !/^\d+$/.test(raw)) return '';
    return raw;
  }

  function deviceId() {
    try {
      var nav = window.navigator || {};
      var screenObj = window.screen || {};
      var parts = [
        nav.userAgent || '',
        nav.language || '',
        Array.isArray(nav.languages) ? nav.languages.join(',') : '',
        String(nav.platform || ''),
        String(nav.hardwareConcurrency || ''),
        String(nav.deviceMemory || ''),
        String(screenObj.width || ''),
        String(screenObj.height || ''),
        String(screenObj.colorDepth || ''),
        String(new Date().getTimezoneOffset()),
        window.location.hostname || '',
      ];
      var raw = parts.join('|');
      var hash = 2166136261;
      for (var i = 0; i < raw.length; i++) {
        hash ^= raw.charCodeAt(i);
        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
      }
      return 'web-' + (hash >>> 0).toString(36);
    } catch (e) {
      return 'web-anon';
    }
  }

  function detailsFromCanvas(canvas) {
    var c = canvas || {};
    var parts = [];
    if (c.style) parts.push('style: ' + c.style);
    if (c.background) parts.push('background: ' + c.background);
    if (c.action) parts.push('action: ' + c.action);
    if (c.text_on_canvas && c.text_on_canvas !== 'none') {
      parts.push('subject: ' + c.text_on_canvas);
    }
    return parts.join('; ');
  }

  function nextStep(canvas) {
    var c = canvas || {};
    if (!c.orientation || c.orientation === 'unknown') return 'orientation';
    if (!c.style) return 'style';
    if (!c.background) return 'background';
    if (!c.action) return 'action';
    if (c.orientation === 'square') {
      if (!c.reference_image_url) return 'upload';
      return 'ready';
    }
    if (!c.text_on_canvas) return 'text';
    if (!c.reference_image_url) return 'upload';
    return 'ready';
  }

  function replyForStepAfterUpload(step) {
    if (step === 'orientation') return "Got your photo. First, what shape should the canvas be?";
    if (step === 'style') return 'Got your photo. Next, pick the art style.';
    if (step === 'background') return 'Got your photo. Now pick the background.';
    if (step === 'action') return 'Got your photo. Last detail — what should be happening in the image?';
    if (step === 'text') return 'Got your photo. Want any text on the canvas? A name looks great.';
    if (step === 'ready') return "Got your photo. Ready to see your canvas come to life?";
    return "Got your photo — I'll use it for the final canvas preview.";
  }

  function pushHistory(role, content) {
    var c = String(content || '').trim();
    if (!c) return;
    state.history.push({ role: role, content: c });
    if (state.history.length > 50) {
      state.history = state.history.slice(-50);
    }
  }

  function renderUserBubble(text) {
    var row = document.createElement('div');
    row.className = 'chat-hp__row chat-hp__row--user chat-hp__thread';
    var bubble = document.createElement('div');
    bubble.className = 'chat-hp__bubble';
    bubble.innerHTML = formatBody(text);
    row.appendChild(bubble);
    messagesEl.insertBefore(row, scrollAnchorEl);
  }

  function renderAssistantBubble(text) {
    var row = document.createElement('div');
    row.className = 'chat-hp__row chat-hp__thread';
    var bubble = document.createElement('div');
    bubble.className = 'chat-hp__bubble';
    bubble.innerHTML = formatBody(text);
    row.appendChild(bubble);
    messagesEl.insertBefore(row, scrollAnchorEl);
    return bubble;
  }

  // Stream `text` into an existing bubble element with a fast ChatGPT-style
  // typewriter effect. HTML tags from formatBody (<p>, <br>, <strong>) emit
  // atomically so markup never appears mid-token. Honors prefers-reduced-motion.
  // CHARS_PER_FRAME tuned to feel thoughtful — at 60fps that's ~120 chars/sec.
  var TYPING_CHARS_PER_FRAME = 2;
  var TYPING_INSTANT_BELOW = 8; // skip the effect for very short blurbs

  // Render queue: serializes thread mutations so back-to-back assistant
  // messages stream one after another instead of all at once. Each task is
  // a function(done) that calls done() when its visible work is complete.
  var renderQueue = [];
  var renderInFlight = false;

  function enqueueRender(task) {
    renderQueue.push(task);
    if (!renderInFlight) runRenderQueue();
  }

  function runRenderQueue() {
    var task = renderQueue.shift();
    if (!task) {
      renderInFlight = false;
      return;
    }
    renderInFlight = true;
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      window.requestAnimationFrame(runRenderQueue);
    }
    try {
      task(done);
    } catch (e) {
      done();
    }
  }

  function streamTextIntoBubble(bubble, text, onDone) {
    if (!bubble) {
      if (onDone) onDone();
      return;
    }
    var fullHtml = formatBody(String(text == null ? '' : text));

    var reducedMotion = false;
    try {
      reducedMotion =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    // Pre-tokenize: each token is either a single visible char or a complete tag.
    var tokens = [];
    var i = 0;
    while (i < fullHtml.length) {
      var ch = fullHtml.charAt(i);
      if (ch === '<') {
        var end = fullHtml.indexOf('>', i);
        if (end === -1) {
          tokens.push(fullHtml.slice(i));
          break;
        }
        tokens.push(fullHtml.slice(i, end + 1));
        i = end + 1;
      } else {
        tokens.push(ch);
        i++;
      }
    }

    if (reducedMotion || tokens.length < TYPING_INSTANT_BELOW) {
      bubble.innerHTML = fullHtml;
      if (onDone) onDone();
      return;
    }

    bubble.classList.add('chat-hp__bubble--typing');
    var revealed = 0;
    function tick() {
      revealed = Math.min(revealed + TYPING_CHARS_PER_FRAME, tokens.length);
      bubble.innerHTML = tokens.slice(0, revealed).join('');
      scrollDown();
      if (revealed < tokens.length) {
        window.requestAnimationFrame(tick);
      } else {
        bubble.classList.remove('chat-hp__bubble--typing');
        if (onDone) onDone();
      }
    }
    window.requestAnimationFrame(tick);
  }

  function appendUser(text, skipHistory) {
    renderUserBubble(text);
    if (!skipHistory) pushHistory('user', text);
    persistedMessages.push({ kind: 'user', text: String(text || '') });
    savePersistedSession();
    scrollDown(true);
  }

  function appendAssistant(text, chips, skipHistory, primaryLabelsOpt) {
    // State updates happen immediately so backend context and persistence
    // stay correct regardless of how the visible queue is draining.
    if (!skipHistory) pushHistory('assistant', text);
    persistedMessages.push({ kind: 'assistant', text: String(text || '') });
    savePersistedSession();

    enqueueRender(function (done) {
      var bubble = renderAssistantBubble('');
      scrollDown(true);
      streamTextIntoBubble(bubble, text, function () {
        if (chips && chips.length) {
          addChips(
            chips,
            function (label) {
              submitUserMessage(label);
            },
            primaryLabelsOpt
          );
          persistedChips = chips.slice();
        } else {
          clearChips();
          persistedChips = [];
        }
        savePersistedSession();
        scrollDown();
        done();
      });
    });
  }

  function appendStatus(text) {
    var row = document.createElement('div');
    row.className = 'chat-hp__row chat-hp__thread chat-hp__row--status';
    var bubble = document.createElement('div');
    bubble.className = 'chat-hp__bubble chat-hp__bubble--status';
    var spinner = document.createElement('span');
    spinner.className = 'chat-hp__bubble-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    var label = document.createElement('span');
    label.className = 'chat-hp__bubble-status-text';
    label.textContent = text || '';
    bubble.appendChild(spinner);
    bubble.appendChild(label);
    row.appendChild(bubble);
    messagesEl.insertBefore(row, scrollAnchorEl);
    scrollDown(true);
    return {
      update: function (next) {
        label.textContent = next || '';
        scrollDown();
      },
      remove: function () {
        if (row.parentNode) row.parentNode.removeChild(row);
      },
    };
  }

  function renderImageBubble(imageUrl, caption, options) {
    var opts = options || {};
    var size = opts.size === 'sm' ? 'sm' : '';
    var row = document.createElement('div');
    row.className = 'chat-hp__row chat-hp__thread';
    var bubble = document.createElement('div');
    bubble.className = 'chat-hp__bubble chat-hp__bubble--image';
    if (size) bubble.className += ' chat-hp__bubble--image-' + size;

    var wrap = document.createElement('div');
    wrap.className = 'chat-hp__image-wrap';
    if (caption && /^Image\s+\d+\b/i.test(caption)) {
      // if caption begins with Image N, show as badge too
      var m = String(caption).match(/^(Image\s+\d+)\b/i);
      if (m && m[1]) {
        var badge = document.createElement('span');
        badge.className = 'chat-hp__image-badge';
        badge.textContent = m[1];
        wrap.appendChild(badge);
      }
    }
    var img = document.createElement('img');
    img.src = imageUrl;
    img.alt = 'Generated canvas preview';
    img.loading = 'lazy';
    img.className = 'chat-hp__image' + (size ? ' chat-hp__image--' + size : '');
    img.addEventListener('load', function () {
      scrollDown(false);
    });
    wrap.appendChild(img);
    bubble.appendChild(wrap);
    if (caption) {
      var cap = document.createElement('p');
      cap.className = 'chat-hp__image-caption';
      cap.textContent = caption;
      bubble.appendChild(cap);
    }
    row.appendChild(bubble);
    messagesEl.insertBefore(row, scrollAnchorEl);
  }

  function appendImage(imageUrl, caption, options) {
    var opts = options || {};
    var entry = {
      kind: 'image',
      url: String(imageUrl || ''),
      caption: String(caption || ''),
    };
    if (opts.size === 'sm') entry.size = 'sm';
    persistedMessages.push(entry);
    savePersistedSession();
    enqueueRender(function (done) {
      renderImageBubble(imageUrl, caption || '', opts);
      scrollDown(true);
      done();
    });
  }

  function renderPresetRow(presetSet) {
    var presets = STYLE_PRESETS[presetSet];
    if (!presets || !presets.length) return null;

    var row = document.createElement('div');
    row.className = 'chat-hp__row chat-hp__thread chat-hp__preset-row';
    row.dataset.presetSet = presetSet;

    var carousel = document.createElement('div');
    carousel.className = 'chat-hp__presets';
    carousel.setAttribute('role', 'list');

    presets.forEach(function (preset, idx) {
      var number = idx + 1;
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'chat-hp__preset';
      card.setAttribute('role', 'listitem');
      card.dataset.presetId = preset.id;
      card.dataset.presetNumber = String(number);
      card.setAttribute('aria-label', number + '. ' + (preset.label || preset.id));

      var img = document.createElement('img');
      img.className = 'chat-hp__preset-image';
      img.src = preset.imageUrl;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = '';
      card.appendChild(img);

      var label = document.createElement('span');
      label.className = 'chat-hp__preset-label';
      label.textContent = number + '. ' + (preset.label || ('Template ' + number));
      card.appendChild(label);

      card.addEventListener('click', function () {
        applyPreset(presetSet, preset.id);
      });

      carousel.appendChild(card);
    });

    row.appendChild(carousel);
    messagesEl.insertBefore(row, scrollAnchorEl);
    return row;
  }

  function appendPresets(presetSet) {
    if (!STYLE_PRESETS[presetSet] || !STYLE_PRESETS[presetSet].length) return;
    persistedMessages.push({ kind: 'presets', presetSet: presetSet });
    savePersistedSession();
    enqueueRender(function (done) {
      var rendered = renderPresetRow(presetSet);
      if (rendered) scrollDown(true);
      done();
    });
  }

  function renderOrientationRow() {
    if (!messagesEl) return null;

    var row = document.createElement('div');
    row.className = 'chat-hp__row chat-hp__thread chat-hp__orientation-row';

    var grid = document.createElement('div');
    grid.className = 'chat-hp__orientations';
    grid.setAttribute('role', 'list');

    ORIENTATION_OPTIONS.forEach(function (opt) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'chat-hp__orientation chat-hp__orientation--' + opt.id;
      card.setAttribute('role', 'listitem');
      card.setAttribute('aria-label', opt.label);
      card.dataset.orientationId = opt.id;

      var thumb = document.createElement('span');
      thumb.className = 'chat-hp__orientation-thumb';
      var img = document.createElement('img');
      img.className = 'chat-hp__orientation-image';
      img.src = opt.imageUrl;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = '';
      // Image may load after we already scrolled — re-scroll once it lands
      // so the picker stays in view as the row grows.
      img.addEventListener('load', function () { scrollDown(); });
      thumb.appendChild(img);
      card.appendChild(thumb);

      var label = document.createElement('span');
      label.className = 'chat-hp__orientation-label';
      label.textContent = opt.label;
      card.appendChild(label);

      card.addEventListener('click', function () {
        submitUserMessage(opt.message);
      });

      grid.appendChild(card);
    });

    row.appendChild(grid);
    messagesEl.insertBefore(row, scrollAnchorEl);
    return row;
  }

  function appendOrientationPicker() {
    if (!messagesEl) return;
    persistedMessages.push({ kind: 'orientation_picker' });
    savePersistedSession();
    enqueueRender(function (done) {
      var rendered = renderOrientationRow();
      if (rendered) scrollDown(true);
      done();
    });
  }

  // Render frame picker as in-thread image swatches (mirrors orientation picker).
  // `labels` is an array of display labels e.g. ["No Frame (default)", "Wood", ...].
  function renderFrameRow(labels) {
    if (!messagesEl || !labels || !labels.length) return null;

    var row = document.createElement('div');
    row.className = 'chat-hp__row chat-hp__thread chat-hp__frame-row';

    var grid = document.createElement('div');
    grid.className = 'chat-hp__frames';
    grid.setAttribute('role', 'list');

    labels.forEach(function (label) {
      var displayLabel = String(label || '').trim();
      if (!displayLabel) return;
      var canonical = displayLabel.replace(/\s*\(default\)\s*$/i, '').trim();
      var imageUrl = FRAME_SWATCH_URLS[canonical] || '';

      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'chat-hp__frame chat-hp__frame--' + canonical.toLowerCase().replace(/\s+/g, '-');
      card.setAttribute('role', 'listitem');
      card.setAttribute('aria-label', displayLabel);

      if (imageUrl) {
        var thumb = document.createElement('span');
        thumb.className = 'chat-hp__frame-thumb';
        var img = document.createElement('img');
        img.className = 'chat-hp__frame-image';
        img.src = imageUrl;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = '';
        img.addEventListener('load', function () { scrollDown(); });
        thumb.appendChild(img);
        card.appendChild(thumb);
      }

      var labelEl = document.createElement('span');
      labelEl.className = 'chat-hp__frame-label';
      labelEl.textContent = displayLabel;
      card.appendChild(labelEl);

      card.addEventListener('click', function () {
        submitUserMessage(displayLabel);
      });

      grid.appendChild(card);
    });

    row.appendChild(grid);
    messagesEl.insertBefore(row, scrollAnchorEl);
    return row;
  }

  function appendFramePicker(labels) {
    if (!messagesEl || !labels || !labels.length) return;
    persistedMessages.push({ kind: 'frame_picker', frames: labels.slice() });
    savePersistedSession();
    enqueueRender(function (done) {
      var rendered = renderFrameRow(labels);
      if (rendered) scrollDown(true);
      done();
    });
  }

  function appendStepReply(text, step, suggestionsOverride) {
    if (step === 'orientation') {
      appendAssistant(text, []);
      appendOrientationPicker();
      return;
    }
    var fallback =
      suggestionsOverride !== undefined
        ? suggestionsOverride
        : STEP_SUGGESTIONS[step] || [];
    appendAssistant(text, fallback);
  }

  function presetNumberOf(presetSet, presetId) {
    var presets = STYLE_PRESETS[presetSet] || [];
    for (var i = 0; i < presets.length; i++) {
      if (presets[i] && presets[i].id === presetId) return i + 1;
    }
    return null;
  }

  function replyForStepAfterPreset(step) {
    if (step === 'text') {
      return 'Want any text on the canvas? Type the exact words (a name looks great), or pick No text.';
    }
    if (step === 'upload') {
      return "Last step — upload a clear photo and I'll bring this canvas to life. Bright, sharp shots work best.";
    }
    if (step === 'ready') return "All set — ready to see your canvas come to life?";
    return 'Style locked in.';
  }

  function startManualFlow() {
    if (state.pending || state.uploading || state.generating || state.addingToCart) return;
    appendUser("I'll do it manually.", false);

    state.canvas = state.canvas || {};
    if (state.canvas.style || state.canvas.background || state.canvas.action) {
      state.canvas = Object.assign({}, state.canvas, {
        style: '',
        background: '',
        action: '',
        preset_id: '',
        preset_number: null,
      });
    }

    var step = nextStep(state.canvas);
    var prompt;
    if (step === 'orientation') {
      prompt = "Got it. First, what shape should the canvas be?";
    } else if (step === 'style') {
      prompt = "Got it — let's design it together. Pick a style or describe one in your own words.";
    } else if (step === 'background') {
      prompt = 'Now pick a background — tap a chip or describe one.';
    } else if (step === 'action') {
      prompt = 'And what should be happening in the image?';
    } else if (step === 'text') {
      prompt = 'Want any text on the canvas? Type it (a name looks great), or pick No text.';
    } else if (step === 'upload') {
      prompt = "Almost there — upload a clear photo and I'll bring it to life.";
    } else {
      prompt = "All set — ready to see your canvas come to life?";
    }

    appendStepReply(prompt, step);
  }

  function applyPreset(presetSet, presetId) {
    if (state.pending || state.uploading || state.generating || state.addingToCart) return;
    var preset = findPresetById(presetSet, presetId);
    if (!preset) return;

    var parsed = parsePresetPrompt(preset.prompt);
    var number = presetNumberOf(presetSet, presetId);

    state.canvas = Object.assign({}, state.canvas || {}, {
      style: parsed.style || (state.canvas && state.canvas.style) || '',
      background: parsed.background || (state.canvas && state.canvas.background) || '',
      action: parsed.action || (state.canvas && state.canvas.action) || '',
      preset_id: preset.id,
      preset_number: number,
      preset_image_url: preset.imageUrl,
    });

    var pickedLabel = (number ? number + '. ' : '') + (preset.label || preset.id);
    pushHistory('user', 'Picked template ' + pickedLabel);
    appendUser('Picked template ' + pickedLabel, true);

    var n = number || 1;
    appendAssistant(
      'Locked in template #' +
        n +
        ':\n\nWant to tweak it? Try "background from 4" or "make it watercolor" — I\'ll mix and match.',
      []
    );

    var step = nextStep(state.canvas);
    appendStepReply(replyForStepAfterPreset(step), step);
  }

  // Single source of truth for the busy state — drives the typing dots
  // and disables inputs whenever the app is mid-request (chat, upload,
  // image gen, or add-to-cart).
  function refreshBusy() {
    var busy =
      !!state.pending ||
      !!state.uploading ||
      !!state.generating ||
      !!state.addingToCart;
    if (typingEl) typingEl.classList.toggle('is-on', busy);
    if (sendBtn) sendBtn.disabled = busy;
    if (inputEl) inputEl.disabled = busy;
    if (uploadBtn) uploadBtn.disabled = busy;
    setChipDisabled(busy);
    if (!busy) scrollDown();
  }

  function setTyping(on) {
    state.pending = !!on;
    refreshBusy();
  }

  function setUploading(on) {
    state.uploading = !!on;
    if (uploadBtn) uploadBtn.textContent = on ? '…' : '+';
    if (fileInputEl && !on) fileInputEl.value = '';
    refreshBusy();
  }

  function clearThreadDom() {
    if (!messagesEl) return;
    var rows = messagesEl.querySelectorAll('.chat-hp__thread');
    for (var i = 0; i < rows.length; i++) rows[i].remove();
    showStartersBlock();
    clearChips();
  }

  function resetChat() {
    state.history = [];
    state.canvas = null;
    state.threadSummary = '';
    state.threadTitle = '';
    state.uploading = false;
    state.addingToCart = false;
    state.lastImageUrl = '';
    state.lastPrintImageUrl = '';
    state.generatedImages = [];
    state.activeImageId = '';
    state.userScrolledUp = false;
    persistedMessages = [];
    persistedChips = [];
    clearPersistedSession();
    clearThreadDom();
    renderStarters();
  }

  function restorePersistedSession() {
    var saved = loadPersistedSession();
    if (!saved) return false;

    var snapshot = saved.state || {};
    var messages = Array.isArray(saved.messages) ? saved.messages : [];
    var chips = Array.isArray(saved.chips) ? saved.chips : [];

    var hasContent =
      messages.length > 0 ||
      (Array.isArray(snapshot.history) && snapshot.history.length > 0) ||
      !!snapshot.canvas;

    if (!hasContent) return false;

    state.history = Array.isArray(snapshot.history) ? snapshot.history.slice() : [];
    state.canvas = snapshot.canvas && typeof snapshot.canvas === 'object' ? snapshot.canvas : null;
    if (state.canvas && state.canvas.project_type) {
      state.canvas.project_type = normalizeProjectType(state.canvas.project_type);
    }
    state.threadSummary = typeof snapshot.threadSummary === 'string' ? snapshot.threadSummary : '';
    state.threadTitle = typeof snapshot.threadTitle === 'string' ? snapshot.threadTitle : '';
    state.lastImageUrl = typeof snapshot.lastImageUrl === 'string' ? snapshot.lastImageUrl : '';
    state.lastPrintImageUrl =
      typeof snapshot.lastPrintImageUrl === 'string' ? snapshot.lastPrintImageUrl : '';
    state.generatedImages = Array.isArray(snapshot.generatedImages) ? snapshot.generatedImages.slice() : [];
    state.activeImageId = typeof snapshot.activeImageId === 'string' ? snapshot.activeImageId : '';

    if (messages.length) hideStartersBlock();

    for (var i = 0; i < messages.length; i++) {
      var m = messages[i] || {};
      if (m.kind === 'user') {
        renderUserBubble(String(m.text || ''));
      } else if (m.kind === 'assistant') {
        renderAssistantBubble(String(m.text || ''));
      } else if (m.kind === 'image' && m.url) {
        renderImageBubble(String(m.url), String(m.caption || ''), { size: m.size === 'sm' ? 'sm' : '' });
      } else if (m.kind === 'presets' && m.presetSet) {
        renderPresetRow(String(m.presetSet));
      } else if (m.kind === 'orientation_picker') {
        renderOrientationRow();
      } else if (m.kind === 'frame_picker' && Array.isArray(m.frames)) {
        renderFrameRow(m.frames);
      }
    }

    persistedMessages = messages.slice();
    persistedChips = chips.slice();

    if (persistedChips.length) {
      // Legacy: pre-thread-picker sessions persisted frame labels as chips.
      // Render them in the thread now so they don't appear tiny in the chips row.
      if (chipsLookLikeFrameOptions(persistedChips)) {
        clearChips();
        renderFrameRow(persistedChips);
        persistedChips = [];
        savePersistedSession();
      } else {
        addChips(persistedChips, function (label) {
          submitUserMessage(label);
        });
      }
    } else {
      clearChips();
    }

    state.userScrolledUp = false;
    scrollDown(true);
    window.setTimeout(function () {
      scrollDown(true);
    }, 200);
    window.setTimeout(function () {
      scrollDown(true);
    }, 600);
    if (document.readyState !== 'complete') {
      window.addEventListener(
        'load',
        function () {
          scrollDown(true);
        },
        { once: true }
      );
    }
    return true;
  }

  function shopName() {
    try {
      if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    } catch (e) {}
    return window.location.hostname;
  }

  function templatesForCurrentCanvas() {
    var presetSet = presetSetForCanvas(state.canvas);
    var presets = presetSet ? STYLE_PRESETS[presetSet] : null;
    if (!presets || !presets.length) return null;
    return presets.map(function (preset, idx) {
      var parsed = parsePresetPrompt(preset.prompt);
      return {
        number: idx + 1,
        id: preset.id,
        label: preset.label || preset.id,
        style: parsed.style || '',
        background: parsed.background || '',
        action: parsed.action || '',
      };
    });
  }

  function payloadFor(message) {
    var previews = (state.generatedImages || []).map(function (g) {
      if (!g) return null;
      return {
        number: g.number,
        preview_url: g.previewUrl || '',
        print_url: g.printUrl || '',
      };
    }).filter(Boolean);
    return {
      message: message,
      history: state.history.slice(-50),
      canvas_state: state.canvas || null,
      templates: templatesForCurrentCanvas(),
      generated_previews: previews.length ? previews : null,
      thread_summary: state.threadSummary || '',
      thread_title: state.threadTitle || '',
      shop: shopName(),
      stream: false,
    };
  }

  function uploadUrl() {
    return API_URL.replace(/\/canvas_chat(?:_v2|_bot_v2)?\/?$/, '/upload_file_v2');
  }

  function uploadReferenceImage(file) {
    if (!file || state.pending || state.uploading) return;
    if (!/^image\//.test(file.type || '')) {
      appendAssistant('Please choose an image file for the reference upload.', []);
      return;
    }

    var formData = new FormData();
    formData.append('file', file);
    setUploading(true);
    appendUser('Uploaded reference image: ' + file.name, true);

    fetch(uploadUrl(), {
      method: 'POST',
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.image_url) throw new Error('Upload response missing image_url');
        state.canvas = Object.assign({}, state.canvas || {}, {
          reference_image_url: data.image_url,
          prompt_upload_reference: false,
        });
        pushHistory('user', 'Uploaded reference image: ' + data.image_url);
        var step = nextStep(state.canvas);
        appendStepReply(replyForStepAfterUpload(step), step);
      })
      .catch(function (err) {
        try {
          console.error('reference upload failed:', err);
        } catch (e) {}
        appendAssistant('Sorry — I could not upload that image. Please try another image.', []);
      })
      .finally(function () {
        setUploading(false);
      });
  }

  var REVISABLE_FIELDS = ['orientation', 'style', 'background', 'action', 'text_on_canvas'];

  function isCanvasRevision(prev, curr) {
    if (!prev || !curr) return false;
    for (var i = 0; i < REVISABLE_FIELDS.length; i++) {
      var k = REVISABLE_FIELDS[i];
      var p = String(prev[k] || '').trim();
      var c = String(curr[k] || '').trim();
      if (!p || !c) continue;
      if (p === 'unknown' || c === 'unknown') continue;
      if (p !== c) return true;
    }
    return false;
  }

  function buildCanvasRecap(canvas, heading) {
    var c = canvas || {};
    var lines = [heading || 'Here is the full canvas so far:'];
    if (c.orientation && c.orientation !== 'unknown') {
      lines.push('• Orientation: ' + c.orientation);
    }
    if (c.style) lines.push('• Style: ' + c.style);
    if (c.background) lines.push('• Background: ' + c.background);
    if (c.action) lines.push('• Action: ' + c.action);
    if (c.text_on_canvas === 'none') {
      lines.push('• Text: none');
    } else if (c.text_on_canvas) {
      lines.push('• Text: "' + c.text_on_canvas + '"');
    }
    return lines.join('\n');
  }

  function handleClientAction(action) {
    if (!action || typeof action !== 'object') return false;

    if (action.type === 'start_over') {
      resetChat();
      return true;
    }

    if (action.type !== 'add_to_cart') return false;

    var n = parseInt(action.image_number, 10);
    var size = String(action.size || '').trim();
    var frame = String(action.frame || '').trim();
    if (!isFinite(n) || !size || !frame) return false;

    var picked = (state.generatedImages || []).find(function (img) {
      return img && img.number === n;
    });
    if (!picked) return false;

    state.activeImageId = picked.id;
    state.canvas = Object.assign({}, state.canvas || picked.canvas || {}, {
      size: size,
      frame: frame,
    });
    ensureFrameDefaultIfUnavailable();
    savePersistedSession();

    var mapped = variantForSelection(state.canvas || {});
    if (!mapped || !mapped.id) {
      var altFrames = availableFramesFor(state.canvas) || [];
      var altText = altFrames.length
        ? ' Available frames for this size: ' + altFrames.join(', ') + '.'
        : '';
      appendAssistant(
        'That combination isn’t available — Image ' +
          n +
          ' in ' +
          size +
          ' with ' +
          frame +
          ' has no matching variant.' +
          altText,
        ['Add to cart', 'Generate again', 'Start over']
      );
      return true;
    }

    appendImage(
      picked.previewUrl,
      'Image ' + n + ' — ' + size + ', ' + frame + '. Ready to add this to your cart?'
    );
    appendAssistant('Confirm to add this canvas to your cart.', [
      'Add to cart',
      'Generate again',
      'Start over',
    ]);
    return true;
  }

  function applyApiPayload(data) {
    if (!data || typeof data !== 'object') {
      throw new Error('Invalid API response');
    }

    if (data.client_action && data.client_action.type === 'start_over') {
      resetChat();
      return;
    }

    var prevCanvas = state.canvas ? Object.assign({}, state.canvas) : null;

    if (data.canvas && typeof data.canvas === 'object') {
      state.canvas = data.canvas;
    }
    if (typeof data.thread_summary === 'string') {
      state.threadSummary = data.thread_summary;
    }
    if (typeof data.thread_title === 'string') {
      state.threadTitle = data.thread_title;
    }

    var reply = data.reply || 'Got it. Tell me one more detail so I can guide the canvas.';
    var suggestions = Array.isArray(data.suggestions) ? data.suggestions : [];
    var step = nextStep(state.canvas || {});

    if (step === 'orientation' && hasStarterSuggestion(suggestions)) {
      appendAssistant(reply, suggestions);
      return;
    }

    var presetSet = presetSetForCanvas(state.canvas);
    if (step === 'style' && presetSet && STYLE_PRESETS[presetSet]) {
      appendAssistant(
        "Here are a few looks our customers love. Tap one to get started — or tap I'll do it manually for full control. Want to mix and match? Type things like \"style from 5\" or \"background from 3\".",
        ["I'll do it manually"]
      );
      appendPresets(presetSet);
      return;
    }

    var revised = isCanvasRevision(prevCanvas, state.canvas);

    if (revised) {
      appendAssistant(reply, []);
      appendStepReply(
        buildCanvasRecap(state.canvas, 'Updated canvas:'),
        step,
        suggestions
      );
    } else {
      appendStepReply(reply, step, suggestions);
    }

    if (handleClientAction(data.client_action)) return;
  }

  function generateImage() {
    if (state.pending || state.uploading || state.generating) return;
    var c = state.canvas || {};

    if (!c.reference_image_url) {
      appendAssistant(
        'I still need a reference photo before I can generate the canvas. Please upload one.',
        ['Upload reference photo']
      );
      return;
    }

    var missing = [];
    if (!c.orientation || c.orientation === 'unknown') missing.push('orientation');
    if (!c.style) missing.push('style');
    if (!c.background) missing.push('background');
    if (!c.action) missing.push('action');
    if (missing.length) {
      appendAssistant(
        'I still need: ' + missing.join(', ') + '. Let me know and I will get it ready.',
        []
      );
      return;
    }

    state.generating = true;
    setTyping(true);
    clearChips();

    var status = appendStatus(GENERATE_PROGRESS_MESSAGES[0]);
    var idx = 0;
    var interval = window.setInterval(function () {
      idx = Math.min(idx + 1, GENERATE_PROGRESS_MESSAGES.length - 1);
      status.update(GENERATE_PROGRESS_MESSAGES[idx]);
    }, 6500);

    var body = {
      image_url: c.reference_image_url,
      orientation: c.orientation,
      details: detailsFromCanvas(c),
      watermark: 1,
    };
    var cid = customerIdForUsage();
    if (cid) body.customer_id = cid;
    else body.device_id = deviceId();

    fetch(IMAGE_EDIT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(
          function (json) {
            return { ok: res.ok, status: res.status, json: json };
          },
          function () {
            return { ok: res.ok, status: res.status, json: null };
          }
        );
      })
      .then(function (out) {
        if (!out.ok || !out.json || !out.json.imageUrl) {
          var err = (out.json && out.json.error) || ('HTTP ' + out.status);
          throw new Error(typeof err === 'string' ? err : JSON.stringify(err));
        }
        status.remove();
        state.lastImageUrl = out.json.imageUrl;
        state.lastPrintImageUrl =
          (out.json && typeof out.json.original_image_url === 'string'
            ? out.json.original_image_url
            : '') || out.json.imageUrl;
        var number = (state.generatedImages ? state.generatedImages.length : 0) + 1;
        var id = 'img-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        var entry = {
          id: id,
          number: number,
          previewUrl: out.json.imageUrl,
          printUrl: state.lastPrintImageUrl,
          canvas: Object.assign({}, state.canvas || {}),
          createdAt: Date.now(),
        };
        state.generatedImages = (state.generatedImages || []).concat([entry]);
        state.activeImageId = id;
        appendImage(out.json.imageUrl, 'Image ' + number + ' — here is your canvas preview.');
        pushHistory(
          'assistant',
          "Here's your canvas preview: " + out.json.imageUrl
        );
        appendAssistant(
          'Love it? Watermark removed at checkout. Next, pick your size and (optional) frame — then we’ll add it to your cart. If you generate multiple previews, you can say things like “image 1, small, no frame”.',
          []
        );
        beginCheckoutSizingFlow();
      })
      .catch(function (err) {
        try {
          console.error('image_edit failed:', err);
        } catch (e) {}
        status.remove();
        var msg =
          err && err.message
            ? err.message
            : 'something went wrong while generating the canvas.';
        if (/reached your limit/i.test(msg)) {
          appendAssistant(msg, ['Start over']);
          return;
        }
        appendAssistant(
          'Sorry — I could not generate the canvas: ' + msg,
          ['Generate again', 'Start over'],
          false,
          ['Generate again']
        );
      })
      .finally(function () {
        window.clearInterval(interval);
        state.generating = false;
        setTyping(false);
      });
  }

  function dispatchCartUpdate(itemCount) {
    try {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              itemCount: typeof itemCount === 'number' ? itemCount : 0,
              source: 'canvas-chat',
            },
          },
        })
      );
    } catch (e) {}

    try {
      window.sessionStorage.setItem(
        'cart-count',
        JSON.stringify({
          value: String(itemCount || 0),
          timestamp: Date.now(),
        })
      );
    } catch (e) {}
  }

  function fetchCartCount() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data) return 0;
        return typeof data.item_count === 'number' ? data.item_count : 0;
      })
      .catch(function () {
        return 0;
      });
  }

  function addToCart(variantId) {
    if (state.pending || state.uploading || state.generating || state.addingToCart) return;
    ensureFrameDefaultIfUnavailable();
    var mapped = variantForSelection(state.canvas || {});
    var id = String((mapped && mapped.id) || variantId || DEFAULT_VARIANT_ID || '').trim();
    if (!id) {
      appendAssistant(
        "I couldn't match a variant for that size/frame. Please pick another size (or choose No Frame).",
        []
      );
      beginCheckoutSizingFlow();
      return;
    }

    state.addingToCart = true;
    setTyping(true);
    clearChips();

    var status = appendStatus('Adding your canvas to the cart…');

    var properties = null;
    var active = (state.generatedImages || []).find(function (img) {
      return img && img.id && img.id === state.activeImageId;
    });
    var previewUrl = (active && active.previewUrl) || state.lastImageUrl;
    var printUrl = (active && active.printUrl) || state.lastPrintImageUrl;

    if (previewUrl) {
      properties = { _preview_image: previewUrl };
      if (printUrl && printUrl !== previewUrl) properties._print_image = printUrl;
      var canvas = state.canvas || {};
      if (canvas.orientation) properties._orientation = String(canvas.orientation);
      if (canvas.style) properties._style = String(canvas.style);
      if (canvas.background) properties._background = String(canvas.background);
      if (canvas.action) properties._action = String(canvas.action);
      if (canvas.size) properties._size = String(canvas.size);
      if (canvas.frame) properties._frame = String(canvas.frame);
      if (canvas.text_on_canvas && canvas.text_on_canvas !== 'none') {
        properties._text_on_canvas = String(canvas.text_on_canvas);
      }
      if (active && active.number) properties._image_number = String(active.number);
    }

    var body = {
      items: [
        {
          id: Number(id) || id,
          quantity: 1,
          properties: properties || undefined,
        },
      ],
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(
          function (json) {
            return { ok: res.ok, status: res.status, json: json };
          },
          function () {
            return { ok: res.ok, status: res.status, json: null };
          }
        );
      })
      .then(function (out) {
        if (!out.ok) {
          var err =
            (out.json && (out.json.description || out.json.message || out.json.error)) ||
            ('HTTP ' + out.status);
          throw new Error(typeof err === 'string' ? err : JSON.stringify(err));
        }
        return fetchCartCount().then(function (count) {
          dispatchCartUpdate(count);
          status.remove();
          appendAssistant(
            "Nice — your canvas is in the cart. Ready to check out, or keep chatting — you can say things like “Image 1 in Large, no frame” if you want to lock in print options.",
            ['View cart', 'Generate again', 'Start over']
          );
        });
      })
      .catch(function (err) {
        try {
          console.error('cart/add failed:', err);
        } catch (e) {}
        status.remove();
        var msg = err && err.message ? err.message : 'something went wrong adding to cart.';
        appendAssistant(
          'Sorry — I could not add this to the cart: ' + msg,
          ['Try add again', 'Generate again', 'Start over'],
          false,
          ['Try add again']
        );
      })
      .finally(function () {
        state.addingToCart = false;
        setTyping(false);
      });
  }

  function callCanvasChat(message) {
    if (!API_URL) {
      appendAssistant('Chat API is not configured yet. Add the canvas_chat URL in the section settings.', []);
      return;
    }
    setTyping(true);
    fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payloadFor(message)),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(applyApiPayload)
      .catch(function (err) {
        try {
          console.error('canvas_chat failed:', err);
        } catch (e) {}
        appendAssistant(
          'Sorry — I could not reach the canvas chat right now. Please try again in a moment.',
          ['Try again', 'Start over'],
          false,
          ['Try again']
        );
      })
      .finally(function () {
        setTyping(false);
      });
  }

  function openFilePicker() {
    if (state.pending || state.uploading || state.generating || state.addingToCart) return;
    if (!fileInputEl) return;
    try {
      fileInputEl.value = '';
    } catch (e) {}
    fileInputEl.click();
  }

  function parseImageRef(text) {
    var t = String(text || '').toLowerCase();
    var m = t.match(/\bimage\s*(\d+)\b/);
    if (!m) m = t.match(/\bimg\s*(\d+)\b/);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    if (!isFinite(n) || n < 1) return null;
    return n;
  }

  function applyInlineSizeFrame(text) {
    // Allows "image 1 small no frame" or "small, black frame" during checkout flow.
    var t = String(text || '').toLowerCase();
    var changed = false;
    if (/\bsmall\b/.test(t)) {
      state.canvas = Object.assign({}, state.canvas || {}, { size: 'Small' });
      changed = true;
    } else if (/\bmedium\b/.test(t)) {
      state.canvas = Object.assign({}, state.canvas || {}, { size: 'Medium' });
      changed = true;
    } else if (/\blarge\b/.test(t)) {
      state.canvas = Object.assign({}, state.canvas || {}, { size: 'Large' });
      changed = true;
    }

    if (/\bno\s*frame\b/.test(t)) {
      state.canvas = Object.assign({}, state.canvas || {}, { frame: 'No Frame' });
      changed = true;
    } else if (/\bdark\s*wood\b/.test(t)) {
      state.canvas = Object.assign({}, state.canvas || {}, { frame: 'Dark Wood' });
      changed = true;
    } else if (/\bwood\b/.test(t)) {
      state.canvas = Object.assign({}, state.canvas || {}, { frame: 'Wood' });
      changed = true;
    } else if (/\bblack\b/.test(t)) {
      state.canvas = Object.assign({}, state.canvas || {}, { frame: 'Black' });
      changed = true;
    }
    return changed;
  }

  function submitUserMessage(text) {
    var t = String(text || '').trim();
    if (!t || state.pending || state.generating || state.addingToCart) return;
    var lowered = t.toLowerCase();
    var step = nextStep(state.canvas || {});

    // Allow referencing a specific generated preview at any time.
    var imgRef = parseImageRef(t);
    if (imgRef != null && state.generatedImages && state.generatedImages.length) {
      var picked = state.generatedImages.find(function (img) {
        return img && img.number === imgRef;
      });
      if (picked) {
        state.activeImageId = picked.id;
      }
    }

    if (t === 'Start over') {
      resetChat();
      return;
    }

    if (UPLOAD_TRIGGERS.indexOf(lowered) !== -1) {
      openFilePicker();
      return;
    }

    if (MANUAL_TRIGGERS.indexOf(lowered) !== -1) {
      startManualFlow();
      return;
    }

    if (GENERATE_TRIGGERS.indexOf(lowered) !== -1) {
      generateImage();
      return;
    }

    if (ADD_TO_CART_TRIGGERS.indexOf(lowered) !== -1) {
      addToCart(DEFAULT_VARIANT_ID);
      return;
    }

    if (VIEW_CART_TRIGGERS.indexOf(lowered) !== -1) {
      window.location.href = '/cart';
      return;
    }

    if (state.checkoutStep === 'size') {
      // Accept "image 1 small no frame" in one message.
      var applied = applyInlineSizeFrame(t);
      if (!applied) {
        var key = lowered;
        if (key.indexOf('small') === 0)
          state.canvas = Object.assign({}, state.canvas || {}, { size: 'Small' });
        else if (key.indexOf('medium') === 0)
          state.canvas = Object.assign({}, state.canvas || {}, { size: 'Medium' });
        else if (key.indexOf('large') === 0)
          state.canvas = Object.assign({}, state.canvas || {}, { size: 'Large' });
      }
      ensureFrameDefaultIfUnavailable();
      // If frames aren't available, we skip right to add-to-cart.
      promptFramePick();
      return;
    }

    if (state.checkoutStep === 'frame') {
      // Accept "image 2 black frame" etc.
      applyInlineSizeFrame(t);
      var frame = t.replace(/\s*\(default\)\s*$/i, '').trim();
      if (/^no\s*frame/i.test(frame)) frame = 'No Frame';
      if (isFrameUnavailableForSelection(Object.assign({}, state.canvas || {}, { frame: frame }))) {
        appendAssistant('Frame is not available for Square Medium — we will use No Frame.', []);
        state.canvas = Object.assign({}, state.canvas || {}, { frame: 'No Frame' });
      } else {
        state.canvas = Object.assign({}, state.canvas || {}, { frame: frame });
      }
      state.checkoutStep = '';
      appendAssistant('Ready to add it to cart?', ['Add to cart', 'Generate again', 'Start over']);
      if (window.DiscoCountdown && typeof window.DiscoCountdown.start === 'function') {
        window.DiscoCountdown.start();
      }
      return;
    }

    appendUser(t);

    if (t === 'Try again') {
      var lastUser = state.history
        .slice()
        .reverse()
        .find(function (m) {
          return m.role === 'user' && m.content !== 'Try again';
        });
      callCanvasChat(lastUser ? lastUser.content : t);
      return;
    }

    callCanvasChat(t);
  }

  function onStarter(s) {
    if (state.pending || state.uploading || state.generating || state.addingToCart) return;
    state.canvas = Object.assign({}, state.canvas || {}, {
      project_type: s.id,
      orientation: 'unknown',
    });
    appendUser(s.label, false);
    var prompt =
      s.starterReply ||
      ('Awesome. Which shape should the ' +
        (s.subject || (String(s.label).toLowerCase() + ' canvas')) +
        ' be?');
    appendStepReply(prompt, 'orientation');
  }

  function renderStarters() {
    if (!startersEl) return;
    startersEl.innerHTML = '';
    STARTERS.forEach(function (s) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'chat-hp__starter';
      btn.setAttribute('aria-label', s.label);

      if (s.imageUrl) {
        var thumb = document.createElement('span');
        thumb.className = 'chat-hp__starter-thumb';
        var img = document.createElement('img');
        img.className = 'chat-hp__starter-image';
        img.src = s.imageUrl;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = '';
        thumb.appendChild(img);
        btn.appendChild(thumb);
      }

      var textWrap = document.createElement('span');
      textWrap.className = 'chat-hp__starter-text';
      var label = document.createElement('span');
      label.className = 'chat-hp__starter-label';
      label.textContent = s.label;
      textWrap.appendChild(label);
      if (s.desc) {
        var desc = document.createElement('span');
        desc.className = 'chat-hp__starter-desc';
        desc.textContent = s.desc;
        textWrap.appendChild(desc);
      }
      btn.appendChild(textWrap);

      btn.addEventListener('click', function () {
        onStarter(s);
      });
      startersEl.appendChild(btn);
    });
  }

  function init() {
    renderStarters();
    restorePersistedSession();
    loadVariantMap();

    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = (inputEl && inputEl.value) || '';
        if (!String(v).trim()) return;
        if (inputEl) inputEl.value = '';
        submitUserMessage(v);
      });
    }

    if (inputEl) {
      inputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          if (formEl) formEl.requestSubmit();
        }
      });
    }

    if (uploadBtn && fileInputEl) {
      uploadBtn.addEventListener('click', function () {
        openFilePicker();
      });

      fileInputEl.addEventListener('change', function () {
        var file = fileInputEl.files && fileInputEl.files[0];
        uploadReferenceImage(file);
      });
    }

    if (messagesEl) {
      messagesEl.addEventListener(
        'scroll',
        function () {
          state.userScrolledUp = !isNearBottom();
        },
        { passive: true }
      );
    }
  }

  init();
})();
